import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import FullCalendar from "@fullcalendar/react";
import BootstrapTheme from "@fullcalendar/bootstrap";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import "./styles.scss";
import { Tooltip } from "bootstrap";
import moment from "moment-timezone";
import {getUserColorForOncall} from "../../helpers/component_helpers";

const OnCallCalender = ({policy, availableUsers, timezone,deletedUsers}) => {
  const today = new Date();
  const endDate = new Date(today);
  endDate.setDate(endDate.getDate() + 180);

  const [calenderData, setCalenderData] = useState([]);
  const [allDay, setAllDay] = useState(false);

  function roundTo12AM(input) {
    const date = input instanceof Date ? new Date(input) : new Date(String(input));
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date input');
    }
    const roundedDate = new Date(date);
    roundedDate.setHours(0, 0, 0, 0);
    roundedDate.setDate(roundedDate.getDate());
    return roundedDate;
  }

  const currentTimeInTimezone = moment.tz(timezone).format();

  useEffect(() => {
    const calData = [];
    let startDate = new Date(policy?.rotation_start_date || today);
    startDate.setHours(0, 0, 0, 0);
    policy.rotation_schedules?.forEach((schedule) => {
      let userId = schedule.user_id;
      const user = availableUsers?.find((user) => user.id === userId);
      const deletedUser = deletedUsers?.find((user) => user.id === userId);
      let endDate = new Date(schedule.end_date);
      let startDate = new Date(schedule.start_date);
      if (policy.rotation_frequency === 'Daily' || policy.rotation_frequency === 'Weekly') {
        endDate = new Date(schedule.end_date);
        startDate = new Date(schedule.start_date);
      }
      const startDateInTimezone = moment(startDate).tz(timezone).format();
      const endDateInTimezone = moment(endDate).tz(timezone).format();
      calData.push({
        title: user?.name || deletedUser?.name || 'Invalid User',
        extendedProps: {
          original_start_date: schedule.start_date,
          original_end_date: schedule.end_date,
        },
        start: startDateInTimezone,
        end: endDateInTimezone,
        color: getUserColorForOncall(user?.id || deletedUser?.id),
      });
      setCalenderData(calData);
      // setAllDay(policy.rotation_frequency === 'Daily' || policy.rotation_frequency === 'Weekly');
    });
  }, [policy.schedules]);


  return (
    <React.Fragment>
      {/* fullcalendar control */}
      <div className="calender-component">
        <FullCalendar
          schedulerLicenseKey="0058366090-fcs-1727974484"
          timeZone={timezone}
          plugins={[
            BootstrapTheme,
            resourceTimelinePlugin
          ]}
          initialView={'timelineWeek'}
          initialDate={today}
          visibleRange={{
            start: today,
          }}
          scrollTime={0}
          weekNumberCalculation="ISO"
          handleWindowResize={true}
          themeSystem="bootstrap"
          contentHeight="150px"
          displayEventTime={false}
          slotLabelInterval={'02:00:00'}
          slotDuration={'02:00:00'}
          eventMinWidth={2}
          slotMinWidth={2}
          slotEventOverlap={false}
          slotLabelFormat={{
            hour: 'numeric',
            minute: '2-digit',
            hour12: false,
            omitZeroMinute: true,
            meridiem: false
          }}
          headerToolbar={{
            center: "title",
          }}
          events={calenderData}
          now={currentTimeInTimezone}
          editable={true}
          eventOrder="level"
          eventOrderStrict={true}
          nowIndicator={true}
          eventDidMount={function (info) {
            const options = {
              timeZone: timezone,
              month: 'short',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              omitZeroMinute: true,
            };

            let startDate = new Date(info.event.extendedProps.original_start_date).toLocaleString('en-US', options);
            if (startDate.includes(':00')){
                startDate = startDate.replace(':00', '');
            }
            let endDate = new Date(info.event.extendedProps.original_end_date).toLocaleString('en-US', options);
            if (endDate.includes(':00')){
                endDate = endDate.replace(':00', '');
            }
            const userName = info.event.title;
            let tooltip = new Tooltip(info.el, {
              title: `${userName}: ${startDate} to ${endDate}`,
              placement: 'right',
              trigger: 'hover',
              container: 'body'
            });
          }}
        />
      </div>
    </React.Fragment>
  );
};

OnCallCalender.propTypes = {
  className: PropTypes.string
};

export default OnCallCalender;